import React from "react";
import { NavLink, useMatches, useParams } from "react-router-dom";
import { Icon } from "semantic-ui-react";
import "../../css/Header.css";

export const Breadcrumbs = props => {
  const params = useParams()
  let matches = useMatches();
  let crumbInfos = matches
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumbInfo))
    .map((match) => match.handle.crumbInfo);
  if(crumbInfos.length === 0) {
    return <></>
  }

  const lastCrumbInfo = crumbInfos[crumbInfos.length-1]
  crumbInfos = crumbInfos.slice(0, crumbInfos.length-1)
  if(lastCrumbInfo['replaceParam']) {
    lastCrumbInfo['text'] = params[lastCrumbInfo['replaceParam']]
  }
  return (
    <div>
      {crumbInfos.map((crumbInfo, i) => {
        let to = crumbInfo.to
        let text = crumbInfo.text
        if(crumbInfo['replaceParam']) {
          text = params[crumbInfo['replaceParam']]
        }
        if(crumbInfo['params']) {
          for(const param of crumbInfo['params']) {
            to = to.replace(":" + param, params[param])
          }
        }
        return (
          <React.Fragment key={i}>
            <span><NavLink className='breadcrumb' to={to}>{text}</NavLink></span>
            <Icon name="caret right"/>
          </React.Fragment>
        )
      })}
      <span key={'lastMatch'}><div className='breadcrumb current' >{lastCrumbInfo['text']}</div></span>

    </div>
  )
}
